<template>
    <div class="profile-dashboard__meta d-flex">

        <div class="profile-dashboard__meta-item d-flex">
            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wDog.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">
                    {{(dashboard && dashboard.funds_available) || 0}} USD
                </div>
                <div class="profile-dashboard__meta-description">{{$store.getters.t('user_dashboard_meta_funds_available')}}</div>
            </div>

        </div>

        <div class="profile-dashboard__meta-item d-flex">

            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wMoney.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">{{(user && user['raised_by_user']) || 0}} USD</div>
                <div class="profile-dashboard__meta-description">{{$store.getters.t('user_dashboard_meta_funds_raised_total')}}</div>
            </div>

        </div>

        <div class="profile-dashboard__meta-item d-flex">

            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wHeart.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">{{(dashboard && dashboard.follows_count) || 0}}</div>
                <div class="profile-dashboard__meta-description">{{$store.getters.t('user_dashboard_meta_followed_animals')}}</div>
            </div>

        </div>

        <div class="profile-dashboard__meta-item d-flex">

            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wDoc.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">{{(dashboard && dashboard.facilities_count) || 0}}</div>
                <div class="profile-dashboard__meta-description">{{$store.getters.t('user_dashboard_meta_ads_posted')}}</div>
            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: "UserDashboardMeta",
    props: ['dashboard', 'user'],
}
</script>

<style scoped>

</style>
